// extracted by mini-css-extract-plugin
export default {"container":"OrderTracking_container__0JbNT","content":"OrderTracking_content__QP2UQ"};